module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_1.cf7e2763.png";